import { FormControl, FormControlLabel, Checkbox as CheckboxMat, FormHelperText } from '@material-ui/core';
import React from 'react';
import { CheckboxProps } from './checkbox.scheme';
import useStyles from './checkbox.styles';

const Checkbox: React.FunctionComponent<CheckboxProps> = (props) => {
    const {
        defaultChecked,
        label,
        error = false,
        id,
        color,
        labelPlacement,
        helperText,
        checked,
        inheritColor,
        disableSidesMargin,
        inputRef,
        onChange,
    } = props;
    const classes = useStyles({ error, inheritColor, disableSidesMargin });

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        onChange && onChange(checked);
    };

    return (
        <FormControl error={error}>
            <FormControlLabel
                control={
                    <CheckboxMat
                        size="medium"
                        color={color}
                        defaultChecked={defaultChecked}
                        checked={checked}
                        onChange={handleOnChange}
                        inputRef={inputRef}
                        id={id}
                        classes={{ root: classes.checkboxRoot }}
                    />
                }
                labelPlacement={labelPlacement}
                label={label}
                classes={{ label: classes.label, root: classes.formControlRoot }}
            />
            {helperText && (
                <FormHelperText classes={{ error: classes.formHelperTextError }}>{helperText}</FormHelperText>
            )}
        </FormControl>
    );
};

export default Checkbox;
